(function ($) {
  $(document).ready(function () {
    filterAppAmend();
    filterWork();
    filterInsurance();
    filterMemberData();
    filterTravelExpenses();
    typedResults();
    $(".member-filter-name").on("input", filterMembers);
    $(".ins-filter-name").on("input", filterMembers);
    $(".app-filter-name").on("input", filterMembers);
    $(".work-filter-name").on("input", filterMembers);
    $(".travel-filter-name").on("input", filterMembers);

    $(".app-ammend-results").on("click", ".print-this-form", function (e) {
      var id = $(this).data("id");
      // console.log('you clicked me, my id is ' + id + '!');
      e.preventDefault();
      printAmendReq(id);
    });

    $(".work-results").on("click", ".print-this-form", function (e) {
      // console.log('you clicked me');
      var id = $(this).data("id");
      // console.log(id);
      e.preventDefault();
      printWork(id);
    });

    // $('.insurance-results').on('click', '.print-this-form', function(e){
    //     console.log('you clicked me');
    //     var id = $(this).data('id');
    //     console.log(id);
    //     e.preventDefault();
    //     previewIns(id);

    // });

    $(".travel-results").on("click", ".print-this-form", function (e) {
      // console.log('you clicked me');
      $(".forms-member-expense-report").show();
      var id = $(this).data("id");
      // console.log(id);
      e.preventDefault();
      var print_d = true;
      printExpense(id, print_d);
    });

    if (typeof preview !== "undefined") {
      if (typeof form !== "undefined") {
        if (form == "app_ammend_req") {
          printAmendReq(preview);
        } else if (form == "cert_insurance_req") {
          previewIns(preview);
        } else if (form == "workers_comp_return") {
          printWork(preview);
        } else if (form == "travel_expenses") {
          var print_d = false;
          printExpense(preview, print_d);
        }
      }
    }
  });

  $(window).load(function () {});

  $(window).resize(function () {});

  //functions
  function typedResults() {
    $(".member-typed-results").on("click", ".one-typed-result", function (e) {
      var id = $(this).data("id");
      var name = $(this).text();
      e.preventDefault();
      $(".member-filter-mem-id").val(id);
      $(".member-filter-name").val(name);
      $(".typed-results").css("display", "none");
    });

    $(".insurance-typed-results").on(
      "click",
      ".one-typed-result",
      function (e) {
        var id = $(this).data("id");
        var name = $(this).text();
        e.preventDefault();
        $(".ins-filter-id").val(id);
        $(".ins-filter-name").val(name);
        $(".typed-results").css("display", "none");
      }
    );

    $(".app-typed-results").on("click", ".one-typed-result", function (e) {
      var id = $(this).data("id");
      var name = $(this).text();
      e.preventDefault();
      $(".app-filter-mem-id").val(id);
      $(".app-filter-name").val(name);
      $(".typed-results").css("display", "none");
    });

    $(".work-typed-results").on("click", ".one-typed-result", function (e) {
      var id = $(this).data("id");
      var name = $(this).text();
      e.preventDefault();
      $(".work-filter-mem-id").val(id);
      $(".work-filter-name").val(name);
      $(".typed-results").css("display", "none");
    });

    $(".travel-typed-results").on("click", ".one-typed-result", function (e) {
      var id = $(this).data("id");
      var name = $(this).text();
      e.preventDefault();
      $(".travel-filter-mem-id").val(id);
      $(".travel-filter-name").val(name);
      $(".typed-results").css("display", "none");
    });
  }

  function filterMembers(event) {
    // console.log( $(this).val() );
    var name = $(this).val();

    jQuery.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: "type_member",
        value: name,
      },
      success: function (response) {
        // console.log('from 145', response);

        var res = $.parseJSON(response);
        // console.log(res);
        $(".typed-results").html("");
        if (res.length == 0) {
          $(".typed-results").css("display", "none");
        } else {
          $(".typed-results").css("display", "block");
        }
        $.map(res, function (value, index) {
          //console.log(value.mem_id + ' : ' + value.name);
          $(".typed-results").append(
            '<a class="one-typed-result" data-id="' +
              value.mem_id +
              '" role="button">' +
              value.name +
              "</a>"
          );
        });
        if (res.length == 0) {
          $(".typed-results").css("display", "none");
        }
      },
    });
  }

  function printAmendReq(id) {
    // if(id <= 902) {
    //     $("#forms-application-form").css({"display": "none"});
    //     $("#forms-application-form-old").css({"display": "block"});
    // } else if(id > 902) {
    //     $("#forms-application-form").css({"display": "block"});
    //     $("#forms-application-form-old").css({"display": "none"});
    // }

    jQuery.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: "application_print",
        value: id,
      },
      success: function (response) {
        var res = $.parseJSON(response);

        //reset radios and checkboxes
        $('input[type="radio"]').removeAttr("checked");
        $('input[type="checkbox"]').removeAttr("checked");
        $.each(res.fields, function (key, value) {
          // console.log(key + ": " + value);
          $("input, textarea")
            .attr("readonly", "readonly")
            .attr("onclick", "return false;");

          $('input[name="' + key + '"][type="text"]').val(value);

          $('input[name="' + key + '"][type="radio"]').each(function () {
            if ($(this).val() == value) {
              $(this).attr("checked", true);
            }
          });

          $('input[name="' + key + '"][type="checkbox"]').each(function () {
            if ($(this).val() == value) {
              $(this).attr("checked", true);
            }
          });

          if (key == "construction_materials") {
            $.each(value, function (i) {
              $('input[type="checkbox"]').each(function () {
                if ($(this).val() == value[i]) {
                  $(this).attr("checked", true);
                }
              });
            });
          }

          // Add Textarea
          if (key == "application_other_property_comments") {
            $("#other_prop_comments_print_helper").html(value);
            $('textarea[name="' + key + '"]').html(value);
          }
          if (key == "other_activity_info") {
            $("#other_activity_info_print_helper").html(value);
            $('textarea[name="' + key + '"]').html(value);
          }
        });

        //open sections if checked

        //NEW
        if ($(".forms-application-form").hasClass("new")) {
          if ($("#property_options_3").is(":checked")) {
            $(".application-property-section").css("display", "block");
          } else {
            $(".application-property-section").css("display", "none");
            $(".building-contents-section, .building-contents-divider").css(
              "display",
              "none"
            );
          }

          if ($("#application_remodeled_existing_building").is(":checked")) {
            $(".remodel-property-section").css("display", "block");
          } else {
            $(".remodel-property-section").css("display", "none");
            $(".remodeled-section, .remodeled-section-divider").css(
              "display",
              "none"
            );
          }

          if ($("#delete_building").is(":checked")) {
            $(".delete-property-section").css("display", "block");
          } else {
            $(".delete-property-section").css("display", "none");
            $(".delete-building-section, .delete-building-section-divider").css(
              "display",
              "none"
            );
          }

          if ($("#delete_decrease_contents").is(":checked")) {
            $(".edit-contents-section").css("display", "block");
          } else {
            $(".edit-contents-section").css("display", "none");
            $(
              ".add-remove-contents-section, .add-remove-contents-section-divider"
            ).css("display", "none");
          }

          if (!$("#application_other_property_comments").val()) {
            $(".property-comments-section").css("display", "none");
          }
          if (!$("#other_activity_info").val()) {
            $(".select-other-section, .application-other-section-new").css(
              "display",
              "none"
            );
          }
        } else {
          //OLD
          if (
            $(
              "#property_options_1, #property_options_2, #property_options_3"
            ).is(":checked")
          ) {
            $(".application-property-section, .select-property-section").css(
              "display",
              "block"
            );
          } else {
            $(".select-property-section").css("display", "none");
          }

          if ($("#other_activity_add, #other_activity_del").is(":checked")) {
            $(".application-other-section, .select-other-section").css(
              "display",
              "block"
            );
          } else {
            $(".select-other-section").css("display", "none");
          }
        }

        //BOTH
        if ($("#other_addition, #other_deletion").is(":checked")) {
          $(
            ".application-other-property-section, .select-other-property-section"
          ).css("display", "block");
        } else {
          $(
            ".select-other-property-section, .application-other-property-section-divider"
          ).css("display", "none");
        }

        if ($("#vehicle_add, #vehicle_delete").is(":checked")) {
          $(".application-vehicle-section, .select-vehicle-section").css(
            "display",
            "block"
          );
        } else {
          $(".select-vehicle-section").css("display", "none");
        }

        if ($("#gen_liability_add, #gen_liability_del").is(":checked")) {
          $(".application-exposures-section, .select-exposures-section").css(
            "display",
            "block"
          );
        } else {
          $(".select-exposures-section").css("display", "none");
        }

        printForm();
      },
      error: function (error) {
        var err = JSON.stringify(error);
        console.log("there has been an error: " + err);
      },
    });
  }

  function printForm() {
    if (window.location.href.indexOf("printform") > -1) {
      window.print();
    }
  }

  //filter Application Ammendment Form
  function filterAppAmend() {
    $("#app-amend-filter").on("submit", function (e) {
      e.preventDefault();
      var form = {
        type: $(".app-filter-type").val(),
        track_id: $(".app-filter-track-id").val(),
        mem_id: $(".app-filter-mem-id").val(),
        name: $(".app-filter-name").val(),
        date_to: $(".app-filter-date-to").val(),
        date_from: $(".app-filter-date-from").val(),
      };

      // console.log(form);

      jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "application_filter",
          value: form,
        },
        success: function (response) {
          //console.log(response);
          var res = $.parseJSON(response);
          // console.log(res);
          if (res == "no results") {
            $(".app-no-results").html("No search results found");
          } else {
            $(".app-no-results").html("");
            //clear previous results
            $(".app-ammend-results")
              .find(".one-result")
              .each(function () {
                $(this).html("");
              });
            //generate new results
            $.map(res, function (value, index) {
              // console.log(value);

              var created = moment(value.created, [
                "YYYY-MM-DD h:mm:ss",
              ]).format("MM/DD/YYYY");
              var effective_date = moment(value.fields.effective_date).format(
                "MM/DD/YYYY"
              );

              $(".app-ammend-results").append(
                '<tr class="one-result"><td>' +
                  value.id +
                  "</td><td>" +
                  value.city +
                  "</td><td>" +
                  created +
                  "</td><td>" +
                  effective_date +
                  "</td><td>" +
                  value.fields.requested_by +
                  '</td><td><a class="preview-this-form" target="_blank" href="?preview=' +
                  value.id +
                  '" role="button"><i class="fa fa-search" aria-hidden="true"></i></a><a class="preview-this-form" target="_blank" href="?print=' +
                  value.id +
                  '&form=aar" role="button"><i class="fa fa-print" aria-hidden="true"></i></a></td></tr>'
              );
            });
          }
        },
        error: function (error) {
          var err = JSON.stringify(error);
          console.log("there has been an error: " + err);
        },
      });
    });
  }

  //print Workers Comp Return Form
  function printWork(id) {
    jQuery.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: "work_print",
        value: id,
      },
      success: function (response) {
        //console.log(response);

        // response.fields.each(function(){

        //     console.log(this);

        // });

        var res = $.parseJSON(response);
        //console.log(res);

        //reset radios and checkboxes
        $('input[type="radio"]').removeAttr("checked");
        $('input[type="checkbox"]').removeAttr("checked");
        $.map(res.fields, function (value, index) {
          // console.log(value.name + ": " + value.value);
          $("input, textarea")
            .attr("readonly", "readonly")
            .attr("onclick", "return false;");

          $('input[name="' + value.name + '"][type="text"]').val(value.value);

          $('input[name="' + value.name + '"][type="radio"]').each(function () {
            if ($(this).val() == value.value) {
              $(this).attr("checked", true);
            }
          });

          $('input[name="' + value.name + '"][type="checkbox"]').each(
            function () {
              if ($(this).val() == value.value) {
                $(this).attr("checked", true);
              }
            }
          );

          // Add Textarea
          if (value.name == "additional_info") {
            $("#addition_info_print_helper").html(value.value);
            $('textarea[name="' + value.name + '"]').html(value.value);
          }
        });

        window.print();
      },
      error: function (error) {
        var err = JSON.stringify(error);
        console.log("there has been an error: " + err);
      },
    });
  }

  //filter Workers Comp Return Form
  function filterWork() {
    $("#workers-comp-filter").on("submit", function (e) {
      e.preventDefault();
      var form = {
        type: $(".work-filter-type").val(),
        track_id: $(".work-filter-track-id").val(),
        mem_id: $(".work-filter-mem-id").val(),
        name: $(".work-filter-name").val(),
        date_to: $(".work-filter-date-to").val(),
        date_from: $(".work-filter-date-from").val(),
      };

      jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "work_filter",
          value: form,
        },
        success: function (response) {
          //console.log(response);
          var res = $.parseJSON(response);
          // console.log(res);
          if (res == "no results") {
            $(".work-no-results").html("No search results found");
          } else {
            $(".work-no-results").html("");
            //clear previous results
            $(".work-results")
              .find(".one-result")
              .each(function () {
                $(this).html("");
              });
            //generate new results
            $.map(res, function (value, index) {
              console.log(value.name + ":" + value.e_name);
              $(".work-results").append(
                '<tr class="one-result"><td>' +
                  value.id +
                  "</td><td>" +
                  value.employer +
                  "</td><td>" +
                  value.e_name +
                  "</td><td>" +
                  value.submitted +
                  '</td><td><a class="preview-this-form" target="_blank" href="?preview=' +
                  value.id +
                  '" role="button"><i class="fa fa-search" aria-hidden="true"></i></a><button class="print-this-form" data-id="' +
                  value.id +
                  '" role="button"><i class="fa fa-print" aria-hidden="true"></i></button></td></tr>'
              );
            });
          }
        },
        error: function (error) {
          var err = JSON.stringify(error);
          console.log("there has been an error: " + err);
        },
      });
    });
  }

  //print Insurance Request
  function previewIns(id) {
    console.log("the ID is: " + id);
    jQuery.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: "insurance_print",
        value: id,
      },
      success: function (response) {
        // response.fields.each(function(){

        //     console.log(this);

        // });

        var res = $.parseJSON(response);
        //Hide form fields if the form id is before 903 (2018)
        if (id <= 935) {
          $(".updated-form").hide();
        } else if (id > 935) {
          $(".updated-form").show();
        }

        //local test
        // if (id <= 120) {
        //     $('.updated-form').hide()
        // } else if (id > 120) {
        //     $('.updated-form').show()
        // }

        //reset radios and checkboxes
        $('input[type="radio"]').removeAttr("checked");
        $('input[type="checkbox"]').removeAttr("checked");
        $.map(res.fields, function (value, index) {
          // console.log(value.name + ": " + value.value);
          $("input, textarea")
            .attr("readonly", "readonly")
            .attr("onclick", "return false;");

          $('input[name="' + value.name + '"][type="text"]').val(value.value);

          $('input[name="' + value.name + '"][type="radio"]').each(function () {
            if ($(this).val() == value.value) {
              // console.log(value.value + ' is being checked');
              $(this).attr("checked", true);
            }
          });

          $('input[name="' + value.name + '"][type="checkbox"]').each(
            function () {
              if ($(this).val() == value.value) {
                $(this).attr("checked", true);
              }
            }
          );

          // Add Textarea
          if (value.name == "purpose") {
            $("#purpose_print_helper").html(value.value);
            $('textarea[name="' + value.name + '"]').html(value.value);
          }
        });

        //window.print();
      },
      error: function (error) {
        var err = JSON.stringify(error);
        console.log("there has been an error: " + err);
      },
    });
  }

  //filter Insurance Request
  function filterInsurance() {
    $("#insurance-certificate-filter").on("submit", function (e) {
      e.preventDefault();
      var form = {
        type: $(".ins-filter-type").val(),
        track_id: $(".ins-filter-track-id").val(),
        mem_id: $(".ins-filter-id").val(),
        name: $(".ins-filter-name").val(),
        date_to: $(".work-filter-date-to").val(),
        date_from: $(".work-filter-date-from").val(),
      };

      jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "insurance_filter",
          value: form,
        },
        success: function (response) {
          //console.log(response);
          var res = $.parseJSON(response);
          // console.log(res);
          if (res == "no results") {
            $(".ins-no-results").html("No search results found");
          } else {
            $(".ins-no-results").html("");
            //clear previous results
            $(".insurance-results")
              .find(".one-result")
              .each(function () {
                $(this).html("");
              });
            //generate new results
            $.map(res, function (value, index) {
              //$('.insurance-results').append('<tr class="one-result"><td>' + value.id + '</td><td>' + value.name + '</td><td>' + value.created + '</td><td>' + value.due + '</td><td>' + value.submitted + '</td><td><a class="print-this-form" data-id="' + value.id + '" role="button">Print</a></td></tr>')
              $(".insurance-results").append(
                '<tr class="one-result"><td>' +
                  value.id +
                  "</td><td>" +
                  value.name +
                  "</td><td>" +
                  value.created +
                  "</td><td>" +
                  value.due +
                  "</td><td>" +
                  value.submitted +
                  '</td><td><a class="preview-this-form" target="_blank" href="?preview=' +
                  value.id +
                  '" role="button"><i class="fa fa-search" aria-hidden="true"></i></a><a class="preview-this-form" target="_blank" href="?print=' +
                  value.id +
                  '&form=coi" role="button"><i class="fa fa-print" aria-hidden="true"></i></a></td></tr>'
              );
            });
          }
        },
        error: function (error) {
          var err = JSON.stringify(error);
          console.log("there has been an error: " + err);
        },
      });
    });
  }

  //print travel expense
  function printExpense(id, print) {
    jQuery.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: "travel_expense_print",
        value: id,
      },
      success: function (response) {
        var res = $.parseJSON(response);
        console.log({ res });
        $.each(res.fields, function (key, value) {
          // console.log(key + ": " + value);

          $("input, textarea")
            .attr("readonly", "readonly")
            .attr("onclick", "return false;");

          $('input[name="' + key + '"][type="text"]').val(value);
        });

        //loop through meals
        var meal_receipts = res.fields.meals;
        console.log({ meal_receipts });
        $(".print-meal-row").remove(); // Remove previous rows once before the loop
        for (var i = 0; i < meal_receipts.length; i++) {
          console.log(meal_receipts[i]);
          var m_receipt;
          if (meal_receipts[i]["receipt"] == "") {
            m_receipt = "";
          } else {
            m_receipt =
              '<a target="_blank" href="' +
              meal_receipts[i]["receipt"] +
              '">Receipt</a>';
          }
          $(".meal-expenses-table tr:first").after(
            '<tr class="print-meal-row"><td>' +
              m_receipt +
              "</td><td>" +
              meal_receipts[i]["date"] +
              "</td><td>" +
              meal_receipts[i]["restaurant"] +
              "</td><td>" +
              meal_receipts[i]["location"] +
              "</td><td>" +
              meal_receipts[i]["amount"] +
              "</td></tr>"
          );
        }

        // Mileage Handling
        var mileage_rate = res.fields.mileage_rate;
        if (res.fields.mileage_rate === null) {
          mileage_rate =
            res.fields.mileage_reimbursement / res.fields.round_trip_miles;
          mileage_rate = mileage_rate.toFixed(3);
        }

        $('[name="mileage_rate"]').val(mileage_rate);

        //loop through lodging
        var lodging_receipts = res.fields.lodgings;
        $(".print-lodging-row").remove(); // Remove previous rows once before the loop
        for (var i = 0; i < lodging_receipts.length; i++) {
          console.log(lodging_receipts[i]);
          var l_receipt;
          if (lodging_receipts[i]["receipt"] == "") {
            l_receipt = "";
          } else {
            l_receipt =
              '<a target="_blank" href="' +
              lodging_receipts[i]["receipt"] +
              '">Receipt</a>';
          }
          $(".lodging-expenses-table tr:first").after(
            '<tr class="print-lodging-row"><td>' +
              l_receipt +
              "</td><td>" +
              lodging_receipts[i]["date"] +
              "</td><td>" +
              lodging_receipts[i]["hotel"] +
              "</td><td>" +
              lodging_receipts[i]["location"] +
              "</td><td>" +
              lodging_receipts[i]["amount"] +
              "</td></tr>"
          );
        }
        //loop through parking
        var parking_receipts = res.fields.parkings;
        $(".print-parking-row").remove(); // Remove previous rows once before the loop
        for (var i = 0; i < parking_receipts.length; i++) {
          console.log(parking_receipts[i]);
          var p_receipt;
          if (parking_receipts[i]["receipt"] == "") {
            p_receipt = "";
          } else {
            p_receipt =
              '<a target="_blank" href="' +
              parking_receipts[i]["receipt"] +
              '">Receipt</a>';
          }
          $(".parking-expenses-table tr:first").after(
            '<tr class="print-parking-row"><td colspan="8">' +
              p_receipt +
              '</td><td colspan="1">' +
              parking_receipts[i]["amount"] +
              "</td></tr>"
          );
        }

        // if (print) {
        //     setTimeout( function(){
        //         window.print();
        //     }, 1000)
        // }
      },
      error: function (error) {
        var err = JSON.stringify(error);
        console.log("there has been an error: " + err);
      },
    });
  }

  //filter travel expense data
  function filterTravelExpenses() {
    $("#travel-expense-filter").on("submit", function (e) {
      e.preventDefault();
      var form = {
        type: $(".travel-filter-type").val(),
        track_id: $(".travel-filter-track-id").val(),
        mem_id: $(".travel-filter-id").val(),
        name: $(".travel-filter-name").val(),
        date_to: $(".travel-filter-date-to").val(),
        date_from: $(".travel-filter-date-from").val(),
      };

      jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "travel_expense_filter",
          value: form,
        },
        success: function (response) {
          //console.log(response);
          var res = $.parseJSON(response);
          // console.log(res);
          if (res == "no results") {
            $(".travel-no-results").html("No search results found");
          } else {
            $(".travel-no-results").html("");
            //clear previous results
            $(".travel-results")
              .find(".one-result")
              .each(function () {
                $(this).html("");
              });
            //generate new results
            $.map(res, function (value, index) {
              $(".travel-results").append(
                '<tr class="one-result"><td>' +
                  value.id +
                  "</td><td>" +
                  value.attendee +
                  "</td><td>" +
                  value.entity +
                  "</td><td>" +
                  value.created +
                  '</td><td><a class="preview-this-form" target="_blank" href="?preview=' +
                  value.id +
                  '" role="button"><i class="fa fa-search" aria-hidden="true"></i></a><button class="print-this-form" data-id="' +
                  value.id +
                  '" role="button"><i class="fa fa-print" aria-hidden="true"></i></button></td></tr>'
              );
            });
          }
        },
        error: function (error) {
          var err = JSON.stringify(error);
          console.log("there has been an error: " + err);
        },
      });
    });
  }

  //filter member data
  function filterMemberData() {
    $("#member-filter").on("submit", function (e) {
      e.preventDefault();
      //console.log('you hit me');
      var form = {
        //type: $('.member-filter-type').val(),
        //track_id: $('.member-filter-track-id').val(),
        mem_id: $(".member-filter-mem-id").val(),
        name: $(".member-filter-name").val(),
        //date_to: $('.member-filter-date-to').val(),
        //date_from: $('.member-filter-date-from').val()
      };

      jQuery.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "member_filter",
          value: form,
        },
        success: function (response) {
          //console.log(response);
          var res = JSON.parse(response);
          // console.log(res);
          if (res == "no results") {
            $(".member-no-results").html("No search results found");
          } else {
            $(".member-no-results").html("");
            $(".forms-member-data").find(".member-data-value").html("");

            $(".md-code").html(res.entity.member_code);
            $(".md-name").html(res.entity.member_name);
            $(".md-phone").html(res.entity.phone);
            $(".md-alt-phone").html(res.entity.alt_phone);
            $(".website-area").html(""); //hide website field
            $(".md-fax").html(res.entity.fax);
            $(".md-address").html(res.entity.mailing_address_1);
            $(".md-address-2").html(res.entity.mailing_address_2);
            $(".md-city").html(res.entity.physical_city);
            $(".md-state").html(res.entity.physical_state);
            $(".md-zip").html(res.entity.physical_zip_code);
            $(".member-roles-section").hide();
            $(".your-contact-info-title").text("Contact Information");

            //primary contacts
            $(".primary-contact-list").html("");
            let primary = res.members
              .filter((item) => item.member_roles.includes("Primary"))
              .map((item, index) => {
                $(".primary-contact-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Primary Contact:</h6>' +
                    '<h6 class="member-data-value md-p-contact">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Primary Contact Title:</h6>' +
                    '<h6 class="member-data-value md-p-contact-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Primary Contact Email:</h6>' +
                    '<h6 class="member-data-value md-p-contact-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    "</div>"
                );
              });
            //city manager
            $(".city-mgmt-list").html("");
            let manager = res.members
              .filter(
                (item) =>
                  item.member_roles.includes("City Manager") ||
                  item.member_roles.includes("Manager / Administrator")
              )
              .map((item, index) => {
                $(".city-mgmt-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Manager:</h6>' +
                    '<h6 class="member-data-value md-city-mgmt">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Manager Title:</h6>' +
                    '<h6 class="member-data-value md-city-mgmt-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Manager Email:</h6>' +
                    '<h6 class="member-data-value md-city-mgmt-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Manager Phone:</h6>' +
                    '<h6 class="member-data-value md-city-mgmt-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
            //city clerk
            $(".city-clerk-list").html("");
            let clerk = res.members
              .filter((item) => item.member_roles.includes("City / Town Clerk"))
              .map((item, index) => {
                $(".city-clerk-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Clerk:</h6>' +
                    '<h6 class="member-data-value md-city-clerk">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Clerk Title:</h6>' +
                    '<h6 class="member-data-value md-city-clerk-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Clerk Email:</h6>' +
                    '<h6 class="member-data-value md-city-clerk-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Clerk Phone:</h6>' +
                    '<h6 class="member-data-value md-city-clerk-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
            //underwriting pc
            $(".upc-contact-list").html("");
            let u_pc = res.members
              .filter((item) => item.member_roles.includes("PC Underwriting"))
              .map((item, index) => {
                $(".upc-contact-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Underwriting Property/Casualty Contact:</h6>' +
                    '<h6 class="member-data-value md-upc-contact">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Underwriting Property/Casualty Contact Title:</h6>' +
                    '<h6 class="member-data-value md-upc-contact-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Underwriting Property/Casualty Contact Email:</h6>' +
                    '<h6 class="member-data-value md-upc-contact-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Underwriting Property/Casualty Contact Phone:</h6>' +
                    '<h6 class="member-data-value md-upc-contact-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
            //underwriting wc
            $(".uwc-contact-list").html("");
            let u_wc = res.members
              .filter((item) => item.member_roles.includes("WC Underwriting"))
              .map((item, index) => {
                $(".uwc-contact-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Underwriting Worker\'s Compensation Contact:</h6>' +
                    '<h6 class="member-data-value md-uwc-contact">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Underwriting Worker\'s Compensation Contact Title:</h6>' +
                    '<h6 class="member-data-value md-uwc-contact-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Underwriting Worker\'s Compensation Contact Email:</h6>' +
                    '<h6 class="member-data-value md-uwc-contact-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Underwriting Worker\'s Compensation Contact Phone:</h6>' +
                    '<h6 class="member-data-value md-uwc-contact-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
            //claims pc
            $(".cpc-contact-list").html("");
            let c_pc = res.members
              .filter((item) => item.member_roles.includes("PC Claims"))
              .map((item, index) => {
                $(".cpc-contact-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Claims Property/Casualty Contact:</h6>' +
                    '<h6 class="member-data-value md-cpc-contact">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Claims Property/Casualty Contact Title:</h6>' +
                    '<h6 class="member-data-value md-cpc-contact-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Claims Property/Casualty Contact Email:</h6>' +
                    '<h6 class="member-data-value md-cpc-contact-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Claims Property/Casualty Contact Phone:</h6>' +
                    '<h6 class="member-data-value md-cpc-contact-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
            //claims wc
            $(".cwc-contact-list").html("");
            let c_wc = res.members
              .filter((item) => item.member_roles.includes("WC Claims"))
              .map((item, index) => {
                $(".cwc-contact-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Claims Worker\'s Compensation Contact:</h6>' +
                    '<h6 class="member-data-value md-cwc-contact">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Claims Worker\'s Compensation Contact Title:</h6>' +
                    '<h6 class="member-data-value md-cwc-contact-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Claims Worker\'s Compensation Contact Email:</h6>' +
                    '<h6 class="member-data-value md-cwc-contact-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Claims Worker\'s Compensation Contact Phone:</h6>' +
                    '<h6 class="member-data-value md-cwc-contact-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
            //loss control
            $(".lc-contact-list").html("");
            let loss = res.members
              .filter((item) => item.member_roles.includes("Risk Control"))
              .map((item, index) => {
                $(".lc-contact-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Risk Control Contact:</h6>' +
                    '<h6 class="member-data-value md-lc-contact">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Risk Control Contact Title:</h6>' +
                    '<h6 class="member-data-value md-lc-contact-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Risk Control Contact Email:</h6>' +
                    '<h6 class="member-data-value md-lc-contact-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Risk Control Contact Phone:</h6>' +
                    '<h6 class="member-data-value md-lc-contact-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
            //accounts
            $(".ap-contact-list").html("");
            let accounts = res.members
              .filter((item) => item.member_roles.includes("Accounts Payable"))
              .map((item, index) => {
                $(".ap-contact-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Accounts Payable Contact:</h6>' +
                    '<h6 class="member-data-value md-ap-contact">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Accounts Payable Contact Title:</h6>' +
                    '<h6 class="member-data-value md-ap-contact-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Accounts Payable Contact Email:</h6>' +
                    '<h6 class="member-data-value md-ap-contact-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Accounts Payable Contact Phone:</h6>' +
                    '<h6 class="member-data-value md-ap-contact-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
            //elected officials
            $(".elected-official-list").html("");
            let elected = res.members
              .filter((item) => item.member_roles.includes("Elected Official"))
              .map((item, index) => {
                $(".elected-official-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Elected Official:</h6>' +
                    '<h6 class="member-data-value md-elected-official">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Elected Official Title:</h6>' +
                    '<h6 class="member-data-value md-elected-official-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Elected Official Email:</h6>' +
                    '<h6 class="member-data-value md-elected-official-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">Elected Official Phone:</h6>' +
                    '<h6 class="member-data-value md-elected-official-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });

            //city attorney
            $(".attorney-list").html("");
            let attorney = res.members
              .filter((item) =>
                item.member_roles.includes("City / Town Attorney")
              )
              .map((item, index) => {
                $(".attorney-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Attorney Contact:</h6>' +
                    '<h6 class="member-data-value md-attorney">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Attorney Contact Title:</h6>' +
                    '<h6 class="member-data-value md-attorney-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Attorney Contact Email:</h6>' +
                    '<h6 class="member-data-value md-attorney-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">City/Town Attorney Contact Phone:</h6>' +
                    '<h6 class="member-data-value md-attorney-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
            //voters
            $(".voter-list").html("");
            let voter = res.members
              .filter(
                (item) =>
                  item.member_roles.includes("Voter") ||
                  item.member_roles.includes("Alternate Voter")
              )
              .map((item, index) => {
                if (item.member_roles.includes("Alternate Voter")) {
                  var alt = "Alternate";
                } else {
                  var alt = "";
                }
                $(".voter-list").append(
                  '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">' +
                    alt +
                    " Voting Representative:</h6>" +
                    '<h6 class="member-data-value md-voter">' +
                    item.first_name +
                    " " +
                    item.last_name +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">' +
                    alt +
                    " Voting Representative Title:</h6>" +
                    '<h6 class="member-data-value md-voter-title">' +
                    item.title +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">' +
                    alt +
                    " Voting Representative Email:</h6>" +
                    '<h6 class="member-data-value md-voter-email">' +
                    item.email +
                    "</h6>" +
                    "</div>" +
                    '<div class="col-xs-12 col-sm-6">' +
                    '<h6 class="member-data-label">' +
                    alt +
                    " Voting Representative Phone:</h6>" +
                    '<h6 class="member-data-value md-voter-phone">' +
                    item.work_phone +
                    "</h6>" +
                    "</div>"
                );
              });
          }
        },
        error: function (error) {
          var err = JSON.stringify(error);
          console.log("there has been an error: " + err);
        },
      });
    });
  }
})(jQuery);
